module.exports = __webpack_public_path__ + "img/left.ef6b1a52.png";